@if (triggerFormControl.value === 'HIGH_ACTIVITY' && !readonly()) {
  <div class="camera-rule__hint">
    <div class="camera-rule__hint-text">
      Hint: To change the sensitivity of the high activity trigger contact
      wildlife&#64;vectronic-aerospace.com
    </div>
  </div>
}
<mat-card class="camera-rule">
  <mat-card-title class="camera-rule__title-wrapper">
    <button mat-icon-button (click)="onClickRule()" [attr.data-testid]="'expand-camera-schedule'">
      @if (cameraScheduleService.isRuleExpanded[index()]) {
        <mat-icon>keyboard_arrow_down</mat-icon>
      }
      @if (!cameraScheduleService.isRuleExpanded[index()]) {
        <mat-icon>keyboard_arrow_right</mat-icon>
      }
    </button>
    <div
      class="camera-rule__title--with-icon"
      (click)="!cameraScheduleService?.isRuleExpanded?.[index()] ? onClickRule() : undefined"
    >
      <mat-icon>list_alt</mat-icon>
      Rule {{ order() + 1 }}
    </div>
    <div class="camera-rule__header-groups">
      @if (cameraScheduleService.isRuleExpanded[index()]) {
        <vectronic-header-group title="Time" icon="timelapse">
          <vectronic-header-item
            label="Duration"
            [value]="getDurationString()"
            [readonly]="readonly()"
            [noEllipsis]="true"
          >
            <vectronic-header-field
              type="radio"
              [options]="TIME_TYPE_OPTIONS"
              [control]="timeTypeFormControl"
              (valueChange)="onTimeTypeChanged($event)"
            ></vectronic-header-field>
            @if (timeTypeFormControl.value === 'temporary') {
              <div>
                <vectronic-header-field
                  type="date"
                  label="Start date"
                  [control]="startDateFormControl"
                  (valueChange)="onStartDateChanged($event)"
                  [minDate]="MIN_DATE"
                  [maxDate]="MAX_DATE"
                ></vectronic-header-field>
                <vectronic-header-field
                  type="date"
                  label="End date"
                  [control]="endDateFormControl"
                  (valueChange)="onEndDateChanged($event)"
                  [minDate]="MIN_DATE"
                  [maxDate]="MAX_DATE"
                ></vectronic-header-field>
                <div>
                  @if (endDateFormControl.hasError('isEndDateAfterStartDate')) {
                    <mat-error> Please select end date after start date</mat-error>
                  }
                </div>
              </div>
            }
          </vectronic-header-item>
          <vectronic-header-item
            label="Repeat Interval"
            [value]="getRepeatString()"
            [readonly]="readonly()"
          >
            <vectronic-header-field
              type="radio"
              [options]="REPEAT_INTERVAL_OPTIONS"
              [control]="repeatIntervalTypeFormControl"
              (valueChange)="onRepeatIntervalChanged($event)"
            ></vectronic-header-field>
            @if (repeatIntervalTypeFormControl.value === 'advanced') {
              <div class="camera-rule__item">
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Day"
                  type="number"
                  [control]="repeatIntervalDayFormControl"
                  (valueChange)="onRepeatIntervalDayChanged($event)"
                  [min]="0"
                ></vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Hour"
                  type="number"
                  [control]="repeatIntervalHourFormControl"
                  (valueChange)="onRepeatIntervalHourChanged($event)"
                  [min]="0"
                  [max]="23"
                ></vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Minute"
                  type="number"
                  [control]="repeatIntervalMinuteFormControl"
                  (valueChange)="onRepeatIntervalMinuteChanged($event)"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            }
          </vectronic-header-item>
        </vectronic-header-group>
        <vectronic-header-group title="Camera" icon="switch_video">
          <vectronic-header-item label="Mode" [value]="getModeString()" [readonly]="readonly()">
            <vectronic-header-field
              type="radio"
              [options]="MODE_OPTIONS"
              [control]="modeFormControl"
              (valueChange)="onModeChanged($any($event))"
            >
            </vectronic-header-field>
          </vectronic-header-item>
          @if (modeFormControl.value === 'VIDEO') {
            <vectronic-header-item
              label="Video Length"
              [value]="getSizeString()"
              [readonly]="readonly()"
            >
              <div class="camera-rule__item">
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Hours"
                  [control]="videoLengthHourFormControl"
                  (valueChange)="updateVideoLength()"
                  [min]="0"
                  [max]="1"
                >
                </vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Minutes"
                  [control]="videoLengthMinuteFormControl"
                  (valueChange)="updateVideoLength()"
                  [min]="0"
                  [max]="59"
                >
                </vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Seconds"
                  [control]="videoLengthSecondFormControl"
                  (valueChange)="updateVideoLength()"
                  [min]="0"
                  [max]="59"
                >
                </vectronic-header-field>
              </div>
            </vectronic-header-item>
          }
          @if (modeFormControl.value === 'PICTURE') {
            <vectronic-header-item label="Count" [value]="getSizeString()" [readonly]="readonly()">
              <vectronic-header-field
                type="number"
                label="Count"
                [control]="photoCountFormControl"
                (valueChange)="updatePhotoCount()"
                [min]="1"
                [max]="100"
              >
              </vectronic-header-field>
              <div class="camera-rule__item">
                @if (modeFormControl.value === 'PICTURE' && photoCountFormControl.value > 1) {
                  <vectronic-header-field
                    class="camera-rule__field"
                    label="Minutes"
                    type="number"
                    [control]="photoIntervalMinuteFormControl"
                    (valueChange)="updatePhotoInterval()"
                    [min]="0"
                    [max]="3"
                  >
                  </vectronic-header-field>
                }
                @if (modeFormControl.value === 'PICTURE' && photoCountFormControl.value > 1) {
                  <vectronic-header-field
                    class="camera-rule__field"
                    label="Seconds"
                    type="number"
                    [control]="photoIntervalSecondFormControl"
                    (valueChange)="updatePhotoInterval()"
                    [min]="0"
                    [max]="59"
                  >
                  </vectronic-header-field>
                }
              </div>
            </vectronic-header-item>
          }
          @if (modeFormControl.value && !hideCameraFormat()) {
            <vectronic-header-item
              label="Format"
              [value]="getCameraFormatString()"
              [noPadding]="true"
              [isClosed]="cameraFormatIsClosed | async"
              [readonly]="readonly()"
            >
              <vectronic-header-field
                type="list"
                [control]="cameraFormatFormControl"
                [isClosed]="cameraFormatIsClosed | async"
                (isClosedChange)="cameraFormatIsClosed.next($event)"
                (valueChange)="updateCameraFormat()"
                [options]="cameraFormatsOptions()"
              >
              </vectronic-header-field>
            </vectronic-header-item>
          }
          @if (modeFormControl.value === 'VIDEO') {
            <vectronic-header-item
              label="Priority"
              [value]="getPriorityString()"
              [noPadding]="true"
              [isClosed]="cameraFormatIsClosed | async"
              [readonly]="readonly()"
            >
              <vectronic-header-field
                type="list"
                [control]="priorityFormControl"
                [isClosed]="cameraFormatIsClosed | async"
                (isClosedChange)="cameraFormatIsClosed.next($event)"
                (valueChange)="updatePriority()"
                [options]="priorityOptions"
              >
              </vectronic-header-field>
            </vectronic-header-item>
          }
        </vectronic-header-group>

        <vectronic-header-group title="Trigger" icon="camera">
          <vectronic-header-item label="Type" [value]="getTriggerString()" [readonly]="readonly()">
            <vectronic-header-field
              type="radio"
              [options]="
                TRIGGER_OPTIONS(
                  hasHighActivityCameraTrigger() ||
                    remoteCommandsService.hasHighActivityCameraTrigger()
                )
              "
              [control]="triggerFormControl"
              (valueChange)="onTriggerChanged($any($event))"
            >
            </vectronic-header-field>
          </vectronic-header-item>

          @if (triggerFormControl.value === 'GPS') {
            <vectronic-header-item
              label="Skip Count"
              [value]="getGpsSkipCountString()"
              [readonly]="readonly()"
            >
              <div class="camera-rule__item">
                <vectronic-header-field
                  type="number"
                  class="camera-rule__field"
                  [control]="gpsSkipCountFormControl"
                  (valueChange)="updateGpsSkipCount()"
                  [min]="0"
                  [max]="15"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          }
          @if (triggerFormControl.value === 'TIMER') {
            <vectronic-header-item
              label="Time Interval"
              [value]="getTimeIntervalString()"
              [readonly]="readonly()"
            >
              <div class="camera-rule__item">
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Days"
                  type="number"
                  [control]="timeIntervalDayFormControl"
                  (valueChange)="updateTimeInterval()"
                  [min]="0"
                  [max]="45"
                >
                </vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Hours"
                  type="number"
                  [control]="timeIntervalHourFormControl"
                  (valueChange)="updateTimeInterval()"
                  [min]="0"
                  [max]="23"
                >
                </vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Minutes"
                  type="number"
                  [control]="timeIntervalMinuteFormControl"
                  (valueChange)="updateTimeInterval()"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          }
          @if (triggerFormControl.value === 'TIMER' || triggerFormControl.value === 'GPS') {
            <vectronic-header-item
              label="Additional Condition"
              [value]="getTimeGpsString()"
              [isClosed]="cameraFormatIsClosed | async"
              [hover]="getHoverTimeGpsString()"
              [readonly]="readonly()"
            >
              <vectronic-header-field
                type="multi"
                [control]="additionalConditionOptionsFormControl"
                (valueChange)="updateAdditionalCondition($event)"
                [options]="ADDITIONAL_CONDITION_TRIGGER_OPTIONS"
                [isClosed]="cameraFormatIsClosed | async"
                (isClosedChange)="cameraFormatIsClosed.next($event)"
              >
              </vectronic-header-field>
            </vectronic-header-item>
          }
          @if (triggerFormControl.value === 'VIT') {
            <vectronic-header-item
              label="Expected"
              [value]="getVitExpectedString()"
              [readonly]="readonly()"
            >
              <div class="camera-rule__item">
                <vectronic-header-field
                  class="camera-rule__field"
                  [options]="VIT_TRIGGER_OPTIONS"
                  [control]="vitExpectedFormControl"
                  (valueChange)="updateVitExpected()"
                  type="autocomplete"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          }
          @if (triggerFormControl.value === 'PROXIMITY_PRELIMANARY') {
            <vectronic-header-item
              label="Lock Time"
              [value]="getProximityActiveTime()"
              [readonly]="readonly()"
            >
              <div class="camera-rule__item">
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Days"
                  type="number"
                  [control]="proximityActiveTimeFormControlDayFormControl"
                  (valueChange)="updateProximityActiveTime()"
                  [min]="0"
                  [max]="45"
                >
                </vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Hours"
                  type="number"
                  [control]="proximityActiveTimeFormControlHourFormControl"
                  (valueChange)="updateProximityActiveTime()"
                  [min]="0"
                  [max]="59"
                >
                </vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  label="Minutes"
                  type="number"
                  [control]="proximityActiveTimeFormControlMinuteFormControl"
                  (valueChange)="updateProximityActiveTime()"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          }
        </vectronic-header-group>
      } @else {
        <div class="camera-rule__header-collapsed-list" (click)="onClickRule()">
          <span class="camera-rule__header-collapsed-item">
            <mat-icon>timelapse</mat-icon>
            {{ getDurationString() }} </span
          ><span>|</span>
          <span class="camera-rule__header-collapsed-item">
            <mat-icon>refresh</mat-icon>
            {{ getRepeatString() }} </span
          ><span>|</span>
          <span class="camera-rule__header-collapsed-item">
            <mat-icon>switch_video</mat-icon>
            {{ modeFormControl.value }} {{ getSizeString() }} {{ getCameraFormatString() }} </span
          ><span>|</span>
          <span class="camera-rule__header-collapsed-item">
            <mat-icon>camera</mat-icon>
            {{ triggerFormControl.value }}
            @if (triggerFormControl.value === 'GPS') {
              {{ gpsSkipCountFormControl.value }} {{ getTimeGpsString() }}
            } @else if (triggerFormControl.value === 'TIMER') {
              {{ getTimeIntervalString() }} {{ getTimeGpsString() }}
            } @else if (triggerFormControl.value === 'VIT') {
              {{ getVitExpectedString() }}
            } @else if (triggerFormControl.value === 'PROXIMITY_PRELIMANARY') {
              {{ getProximityActiveTime() }}
            }
          </span>
        </div>
      }
    </div>
  </mat-card-title>

  <mat-divider></mat-divider>

  <mat-card-content class="camera-rule__content">
    <div class="camera-rule__form">
      <div class="camera-rule__start-end">
        @if (cameraScheduleService.isRuleExpanded[index()]) {
          <vectronic-header-group title="Start" icon="compare_arrows">
            <vectronic-header-item [value]="getStartString()" [readonly]="readonly()">
              <div class="camera-rule__item">
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Hour"
                  [control]="startHourFormControl"
                  (valueChange)="updateStart()"
                  [min]="0"
                  [max]="23"
                ></vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Minute"
                  [control]="startMinuteFormControl"
                  (valueChange)="updateStart()"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          </vectronic-header-group>

          <vectronic-header-group title="End" icon="compare_arrows">
            <vectronic-header-item [value]="getEndString()" [readonly]="readonly()">
              <div class="camera-rule__item">
                @if (isWeekly(rule().cycleTime)) {
                  <vectronic-header-field
                    class="camera-rule__field"
                    type="select"
                    label="Weekday"
                    [options]="weekdays"
                    [control]="endWeekdayFormControl"
                    (valueChange)="onEndWeekdayChanged($event)"
                  ></vectronic-header-field>
                }
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Hour"
                  [control]="endHourFormControl"
                  (valueChange)="updateEnd()"
                  [min]="0"
                  [max]="isWeekly(rule().cycleTime) || isDaily(rule().cycleTime) ? 24 : undefined"
                ></vectronic-header-field>
                <vectronic-header-field
                  class="camera-rule__field"
                  type="number"
                  label="Minute"
                  [control]="endMinuteFormControl"
                  (valueChange)="updateEnd()"
                  [min]="0"
                  [max]="59"
                ></vectronic-header-field>
              </div>
            </vectronic-header-item>
          </vectronic-header-group>
        } @else {
          <div class="camera-rule__header-collapsed-list" (click)="onClickRule()">
            <span class="camera-rule__header-collapsed-item">
              <mat-icon>timelapse</mat-icon>
              {{ getStartString() }} -> {{ getEndString() }}
            </span>
          </div>
        }
      </div>
      @if (cameraScheduleService.isRuleExpanded[index()]) {
        <rc-camera-slider
          [trigger]="triggerFormControl.value"
          [ruleIndex]="index()"
          [cycleTime]="rule().cycleTime"
          [startDate]="startDateFormControl.value"
          [offset]="getOffset(rule().startTime)"
          [onTime]="rule().onTime"
          [isRuleExpanded]="cameraScheduleService.isRuleExpanded[index()]"
          [photoCount]="rule().size"
          [pictureInterval]="rule().pictureInterval"
          [videoLength]="rule().size"
          [mode]="modeFormControl.value"
          [timeInterval]="rule().mainTriggerValue"
          [readonly]="readonly()"
        ></rc-camera-slider>
      }
    </div>
  </mat-card-content>
  @if (!readonly()) {
    <mat-card-actions align="end">
      <div [matTooltip]="isDeletable() ? 'Delete Schedule' : 'Specify at least one schedule'">
        <button
          mat-button
          [attr.data-testid]="'delete-rule-button'"
          (click)="onClickRemoveRule()"
          color="warn"
          [disabled]="!isDeletable()"
        >
          <mat-icon>delete</mat-icon>
          Remove Rule
        </button>
      </div>
    </mat-card-actions>
  }
</mat-card>
